import React, { useEffect, useRef, useState, useLayoutEffect } from 'react'
import Carrusel from '../../hooks/carrusel';

function SliderImage({data}) {
    const listRef = useRef();
    const divRef = useRef();
    const Increment = useRef(-1);
    const [currentIndex, setCurrentIndex] = useState(-1);
  
    useEffect(() => {
      if (Increment.current > -1)
      {  
        const listNode = listRef.current;
        const divNode = divRef.current;
        const imgNode = listNode.querySelectorAll("li > img")[currentIndex];
        const leyNode = divNode.querySelectorAll("li")[currentIndex];
        
        if (imgNode) {
          imgNode.scrollIntoView({
            behavior: "smooth"
          });
        }
        if (leyNode) {
          const div = document.querySelector("#divText");
          if (div)
          {
            div.innerHTML=leyNode.innerHTML;
          }
        }
      }  
    }, [currentIndex]);
  
    useLayoutEffect(() =>{
         const interval = setInterval(() => {
              goAutomatico();
          }, 10000 );
      //Clearing the interval
        return () => clearInterval(interval);
  
    },[]);

    const GenerarRutaArch = (Datos) => {
        const ItemId = Datos.ItemId;
        const ArchivoId = Datos.ArchivoId;
        const Formato = Datos.Formato;
        const NombreArch = ArchivoId + "_" + ItemId + "." + Formato;
        
        const RutaArch =  `${import.meta.env.BASE_URL}api/static/${Datos.RutaArch}/${NombreArch}`;
        return RutaArch;
      };
    
    const scrollToImage = (direction) => {
        if (direction === 'prev') {
          setCurrentIndex(curr => {
            const isFirstSlide = currentIndex === 0;
            return isFirstSlide ? 0 : curr - 1;
          })
        } else {
          const isLastSlide = currentIndex === data.length - 1;
          if (!isLastSlide) {
            setCurrentIndex(curr => curr + 1);
          }
        }
      }
    
      const goAutomatico =() =>{
        const listNode = listRef.current;
        const imgNode = listNode.querySelectorAll("li > img");
        if (imgNode)
        {
         const isLastSlide = Increment.current === data.length - 1;
         if (!isLastSlide) {
           Increment.current = Increment.current + 1
           setCurrentIndex(Increment.current);
         }
         else
         {
          Increment.current = 0;
          setCurrentIndex(Increment.current)
         }
        } 
    }
   
  return(<>
  <div className="flex w-full h-full">
  <div className="flex w-full h-full">
       <Carrusel data={data} />
   </div>     
        
  </div>
 
  </>);  
}
export default SliderImage;